<template>
  <div class="front-products front-container">
    <ul class="d-flex justify-content-center align-items-center mt-3">
      <li
        class="mr-2"
        @click="filterData('all')"
        :class="{ active: selected === 'all' }"
      >
        全部商品
      </li>
      <li
        class="mr-2"
        @click="filterData('網頁設計')"
        :class="{ active: selected === '網頁設計' }"
      >
        網頁設計
      </li>
      <li
        class="mr-2"
        @click="filterData('平面設計')"
        :class="{ active: selected === '平面設計' }"
      >
        平面設計
      </li>
      <li
        @click="filterData('系統設計')"
        :class="{ active: selected === '系統設計' }"
      >
        產品設計
      </li>
    </ul>
    <ul class="d-flex flex-wrap justify-content-center">
      <li class="mt-5" v-for="item in filterProducts" :key="item.id">
        <Card :insideItem="item"></Card>
      </li>
    </ul>
    <div class="fixed-title"><span>產品</span></div>
  </div>
</template>

<script>
import Card from './components/ProductCard';
import frontProductsRequest from '@/assets/js/api/front/apiFrontProducts';
export default {
  components: { Card },
  data() {
    return {
      products: [],
      filterProducts: [],
      selected: 'all',
    };
  },
  created() {
    frontProductsRequest.then(res => {
      this.products = res.data.data;
      this.filterProducts = res.data.data;
    });
  },
  mounted() {
    this.$nextTick(() => {
      document.getElementById('check').checked = false;
    });
  },
  methods: {
    filterData(string) {
      this.selected = string;
      if (string === 'all') {
        this.filterProducts = this.products;
        return;
      }
      this.filterProducts = this.products.filter(product => {
        return product.category === string;
      });
    },
  },
  computed: {
    // 確保單向數據不會被修改到原本
    productsProps() {
      return this.products;
    },
  },
};
</script>

<style lang="scss" scoped></style>
